import Loading from 'components/FullScreenLoading';
import {useContext, useEffect, useRef, useState} from 'react';
import {useLocation, useNavigate} from 'react-router-dom';
import {Button, Divider} from 'antd';
import IMG from 'assets/profile-picture.png';
import SERVICES from 'services';
import moment from 'moment-timezone';
import QRCodeStyling, {Options} from 'qr-code-styling';
import {AuthContext} from 'context/Auth.context';

const QROptions: Options = {
	width: 200,
	height: 200,
	data: undefined,
	margin: 0,
	qrOptions: {
		typeNumber: 0,
		mode: 'Byte',
		errorCorrectionLevel: 'Q'
	},
	imageOptions: {hideBackgroundDots: true, imageSize: 0.3, margin: 0},
	dotsOptions: {type: 'extra-rounded', color: '#002494'},
	backgroundOptions: {color: '#ffffff'},
	image: 'data:image/png;base64,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',
	//@ts-ignore
	dotsOptionsHelper: {
		colorType: {
			single: true,
			gradient: false
		},
		gradient: {
			linear: true,
			radial: false,
			color1: '#6a1a4c',
			color2: '#6a1a4c',
			rotation: '0'
		}
	},
	cornersSquareOptions: {
		type: 'square',
		color: '#002494',
		gradient: undefined
	},
	cornersSquareOptionsHelper: {
		colorType: {single: true, gradient: false},
		gradient: {
			linear: true,
			radial: false,
			color1: '#000000',
			color2: '#000000',
			rotation: '0'
		}
	},
	cornersDotOptions: {type: 'square', color: '#ec2939'},
	cornersDotOptionsHelper: {
		colorType: {single: true, gradient: false},
		gradient: {
			linear: true,
			radial: false,
			color1: '#000000',
			color2: '#000000',
			rotation: '0'
		}
	},
	backgroundOptionsHelper: {
		colorType: {single: true, gradient: false},
		gradient: {
			linear: true,
			radial: false,
			color1: '#ffffff',
			color2: '#ffffff',
			rotation: '0'
		}
	}
};

interface DataTypes {
	path: string;
	facultyName: string;
	examDate: string;
	candidateMiddleName: string;
	candidateName: string;
	candidateLastName: string;
	examName: string;
	classroom: string;
	tableNumber: string;
}

const Candidate = () => {
	const location = useLocation();
	const navigate = useNavigate();
	const [loading, setLoading] = useState(true);
	const [data, setData] = useState<DataTypes | null>(null);
	const imageRef = useRef() as React.MutableRefObject<HTMLImageElement>;
	const {
		state: {student}
	} = useContext(AuthContext);

	const role = student ? 'STUDENT' : 'CANDIDATE';

	const urlParams = new URLSearchParams(location.search);
	const candidateID = urlParams.get('candidateID');
	const examID = urlParams.get('examID');

	useEffect(() => {
		if (candidateID && examID) {
			SERVICES.USER.getOpenInfo({candidateID, examID})
				.then(res => {
					setData(res.data);
				})
				.finally(() => {
					setLoading(false);
				});
		} else {
			navigate('/');
		}
	}, []);

	const QRCode = new QRCodeStyling({
		...QROptions,
		data: `${window.location.origin}/candidate?candidateID=${candidateID}&examID=${examID}`
	});

	const print = () => {
		window.print();
	};

	const ref = useRef<HTMLDivElement>(null);

	useEffect(() => {
		let node: null | HTMLCanvasElement = null;
		if (ref.current) {
			QRCode.append(ref.current);
			node = ref.current.querySelector('canvas');
		}

		return () => {
			if (node) {
				ref.current?.removeChild(node);
			}
		};
	}, [loading]);

	if (loading || !data) return <Loading />;

	if (Array.isArray(data))
		return <Loading tip="Տվյալ դիմորդի համար քննություն չի հայտնաբերվել" size="small" />;

	return (
		<div className="container">
			<div className="main-card">
				<div
					className="content"
					style={{
						width: '100%'
					}}>
					<div
						className="info-wrapper"
						style={{
							margin: 0,
							display: 'flex',
							flexDirection: 'column',
							alignItems: 'center',
							justifyContent: 'center'
						}}>
						<div style={{height: '100%', width: 'fit-content'}}>
							<img
								ref={imageRef}
								src={process.env.REACT_APP_API_URL + '/' + data.path}
								onError={() => {
									imageRef.current.src = IMG;
									imageRef.current.width = 100;
								}}
								width={200}
							/>
						</div>

						<div
							className="header"
							style={{width: 'max-content', marginTop: 15, marginBottom: 0}}>
							{data.candidateName} {data.candidateLastName} {data.candidateMiddleName}
						</div>
					</div>
				</div>
			</div>
			<div className="profile-info">
				<div className="form-header">
					<h1 className="form-title">
						Անցաթուղթ{' '}
						<Button onClick={print} type="primary">
							Տպել
						</Button>
					</h1>
				</div>

				<Divider style={{borderColor: '#002494', margin: 0, marginBottom: 16}} />

				<div className="candidate-info">
					<div className="info">
						<div className="key">Ֆակուլտետ՝ </div>
						<div className="value">{data.facultyName}</div>
					</div>
					<div className="info">
						<div className="key">Քննություն՝ </div>
						<div className="value">{data.examName}</div>
					</div>
					<div className="info">
						<div className="key">Քննության ամսաթիվ՝ </div>
						<div className="value">
							{moment(data.examDate).tz('Asia/Yerevan').format('YYYY-MM-DD HH:mm')}
						</div>
					</div>
					{/* <div className="info">
						<div className="key">Լսարան՝ </div>
						<div className="value">{data.classroom}</div>
					</div>
					<div className="info">
						<div className="key">Նստարան </div>
						<div className="value">{data.tableNumber}</div>
					</div> */}
				</div>
			</div>
			<div style={{marginTop: 50}} ref={ref} />
		</div>
	);
};

export default Candidate;
